module.exports = __webpack_public_path__ + "static/img/2_9_1.93236bca.jpg";